import {
  ACCOUNT_STORE_TYPE,
  MOMENT_STORE_TYPE,
  ESHOP_STORE_TYPE,
  MENU_CUSTOMIZABLE_SHOP_TEMPLATE_TYPE,
} from "@constants/shops";

const NAME_CHAR_LIMIT = 50;

export const getShopInitializeFormValues = (shop) => {
  const { name = "", config = {} } = shop;
  const defaultFormFieldValidates = { presence: true };

  const formValues = {
    shopName: {
      value: name,
      validates: { ...defaultFormFieldValidates, length: { max: NAME_CHAR_LIMIT } },
    },
    currency: {
      value: config?.currencyCode,
      validates: { ...defaultFormFieldValidates },
    },
  };
  return formValues;
};

export const isAccountStore = (store) => store?.config?.type === ACCOUNT_STORE_TYPE;
export const isMomentStore = (store) => store?.config?.type === MOMENT_STORE_TYPE;
export const getIsMenuCustomizableShop = (templateType) =>
  templateType === MENU_CUSTOMIZABLE_SHOP_TEMPLATE_TYPE;

export const isEshopStore = (storeType) => storeType === ESHOP_STORE_TYPE;

export const shopDetailMarketingPageAbsent = (config, type) =>
  isAccountStore({ config }) || isEshopStore(type);

export const getShopFeUrlWithCountryCode = ({
  domain,
  countryCode,
  language,
  shopSlug,
  shopNumber,
  withFeaturedSection,
}) =>
  `${domain || window.location.origin}/${countryCode}/${language}/stores/${shopSlug}/${shopNumber}${
    withFeaturedSection ? "#featured" : ""
  }`;
